import React, { FC } from 'react';
import { HttpError, HttpStatusCode } from '@core/http';

import * as Styled from './ErrorPage.styles';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

interface ErrorPageProps {
  error?: HttpError;
}

const ErrorPage: FC<ErrorPageProps> = ({ error = HttpError.notFound }) => {
  return (
    <Styled.ErrorPageContainer>
      <div>
        <h1>
          {HttpStatusCode.NOT_FOUND === error.status
            ? 'La page que vous cherchez est introuvable'
            : `Une erreur ${error.status} est survenue`}
        </h1>
      </div>

      <p>Nous vous invitons à revenir à l'accueil</p>

      <Button as={Link} primary to="/">
        Revenir à l'accueil
      </Button>
    </Styled.ErrorPageContainer>
  );
};

export default ErrorPage;
